module.exports = __webpack_public_path__ + "img/logo-muhaye-blue.00379e17.png";